import {
  LAYOUT_ANIMATION_DELTA_SNAP_PX,
  LAYOUT_ANIMATION_DURATION,
  LAYOUT_ANIMATION_DURATION_SMALL_DELTA,
} from './constants';
import { isNoteParkedBesideHost } from '../../utils/noteUtils';

export function isFinitePosition(pos) {
  return pos && Number.isFinite(pos.x) && Number.isFinite(pos.y);
}

export function getManualPositions(tasks, customPositions) {
  const raw = {};
  tasks.forEach((task) => {
    const custom = customPositions?.[task.id];
    if (isFinitePosition(custom)) {
      raw[task.id] = { x: custom.x, y: custom.y };
      return;
    }
    if (Number.isFinite(task.x) && Number.isFinite(task.y)) {
      raw[task.id] = { x: task.x, y: task.y };
    }
  });

  const positions = {};
  tasks.forEach((task) => {
    const pos = raw[task.id];
    if (!pos) return;
    const custom = customPositions?.[task.id];
    // Old "glue to host.right" coords occupy the next mission's cell.
    // Don't treat those as a manual hold — let ELK place the note.
    if (!isFinitePosition(custom) && isNoteParkedBesideHost(task, tasks, raw)) {
      return;
    }
    positions[task.id] = pos;
  });
  return positions;
}

export function manualPositionsDivergeFromElk(manualPositions, elkPositions, tasks, eps = 1.5) {
  if (!manualPositions || !elkPositions || !tasks?.length) return false;
  return tasks.some((task) => {
    const manual = manualPositions[task.id];
    if (!manual) return false;
    const elk = elkPositions[task.id];
    if (!isFinitePosition(elk)) return true;
    return Math.abs(manual.x - elk.x) > eps || Math.abs(manual.y - elk.y) > eps;
  });
}

function maxHeldToNextDelta(held, nextPos, tasks) {
  if (!held || !nextPos || !tasks?.length) return Infinity;
  let max = 0;
  let any = false;
  for (const t of tasks) {
    const h = held[t.id];
    const n = nextPos[t.id];
    if (!isFinitePosition(h) || !isFinitePosition(n)) continue;
    any = true;
    const d = Math.max(Math.abs(h.x - n.x), Math.abs(h.y - n.y));
    if (d > max) max = d;
  }
  return any ? max : Infinity;
}

export function resolveLayoutAnimMs({ isInstantLayout, isExplicitAnimatedLayout, held, nextPos, tasks }) {
  if (isInstantLayout) return 0;
  if (isExplicitAnimatedLayout) return LAYOUT_ANIMATION_DURATION;
  const d = maxHeldToNextDelta(held, nextPos, tasks);
  if (d <= LAYOUT_ANIMATION_DELTA_SNAP_PX) return LAYOUT_ANIMATION_DURATION_SMALL_DELTA;
  return LAYOUT_ANIMATION_DURATION;
}
